module.exports = __webpack_public_path__ + "img/card-bg-02.3cd9128d.png";